export default __webpack_public_path__ + "static/media/home-personal-portfolio-bg-img-01.dadafd7b.jpg";